<template>
  <div id="bulk-upload-city">
    <v-card>
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title>{{ PageTitle }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <v-container style="overflow: hidden">
        <v-card-title></v-card-title>
        <v-card-text>
          <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
            <b-spinner
              variant="primary"
              type="grow"
              label="Loading..."
            ></b-spinner>
          </div>
          <v-row wrap>
            <v-col align="center" cols="12" md="12">
              <v-btn
                elevation="30"
                shaped
                tile
                small
                class="font-size-h6 mr-3 white--text"
                @click.prevent="refreshPageData"
                color="#a4c639"
                >Refresh</v-btn
              >
            </v-col>
          </v-row>
          <v-form
            ref="form1"
            v-model="valid1"
            lazy-validation
            v-on:submit.prevent="submitForm"
          >
            <v-container>
              <v-row wrap>
                <v-col cols="12" md="12">
                  <p>
                    <span class="text-danger">*</span> Please upload CSV/Excel
                    file with headers: <b>City, Pincode, Latitude, Longitude</b>
                  </p>
                </v-col>
                <v-col cols="12" md="12">
                  <v-file-input
                    v-model="UploadedFile"
                    label="Choose File"
                    placeholder="Select your file"
                    prepend-icon="mdi-paperclip"
                    outlined
                    dense
                    :rules="[(v) => !!v || 'File is required']"
                    accept=".csv, .xls, .xlsx"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>
              </v-row>
              <v-row wrap>
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitForm"
                    :loading="SubmitFlag"
                    elevation="30"
                    shaped
                    tile
                    small
                    color="#1db954"
                    class="font-size-h6 px-10 mr-3 white--text"
                    >Upload</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-form>

          <!-- Error Table -->
          <v-container v-if="errorTableData.length > 0">
            <v-row>
              <v-col cols="12">
                <v-alert type="error" outlined dense>
                  Some records failed to upload. Please check the details below.
                </v-alert>
                <v-data-table
                  :headers="errorTableHeaders"
                  :items="errorTableData"
                  :items-per-page="-1"
                  hide-default-footer
                  class="elevation-1"
                ></v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  props: {
    BulkUploadPrompt: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      LoadingFlag: false,
      SubmitFlag: false,
      PageTitle: "Bulk Upload Cities",
      UploadedFile: null,

      errorTableData: [],
      errorTableHeaders: [
        { text: "Line No", value: "LineNo" },
        { text: "Error", value: "Error" },
      ],
    };
  },
  methods: {
    refreshPageData() {
      this.UploadedFile = null;
      this.errorTableData = [];
      this.valid1 = true;
    },
    closePrompt() {
      this.$emit("hideDialog");
    },
    submitForm() {
      if (this.$refs.form1.validate()) {
        this.SubmitFlag = true;
        this.errorTableData = [];

        let formData = new FormData();
        formData.append("UploadedFile", this.UploadedFile);
        formData.append("UserInterface", 1);

        let server_url = companyConfig.apiURL;
        let token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        let add_url = server_url + "api/city/bulk-upload";

        const thisIns = this;

        this.$http({
          url: add_url,
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + token,
          },
        })
          .then(function (response) {
            thisIns.SubmitFlag = false;
            let flag = response.data.flag;
            let output = response.data.output;
            let records = response.data.records;

            if (flag == 1) {
              if (
                records &&
                records.TableData &&
                records.TableData.length > 0
              ) {
                thisIns.errorTableData = records.TableData;
                thisIns.sweetAlert("warning", output, false);
              } else {
                thisIns.sweetAlert("success", output, true);
                thisIns.closePrompt();
              }
            } else {
              thisIns.sweetAlert("error", output, false);
              if (records && records.TableData) {
                thisIns.errorTableData = records.TableData;
              }
            }
          })
          .catch(function (error) {
            thisIns.SubmitFlag = false;
            console.log("error=" + error);
          });
      }
    },
  },
};
</script>

<style lang="scss">
#bulk-upload-city {
  .v-app-bar {
    border-radius: 4px 4px 0 0;
  }
}
</style>
